var head = document.getElementsByTagName("head")[0];
var body = document.getElementsByTagName("body")[0];

function createNodes(s) {
    var div = document.createElement("div");
    div.innerHTML = s;
    return div.childNodes;
}

export function append(s) {
    var nodes = createNodes(s);
    for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i].cloneNode(true);
        body.appendChild(node);
    }
}

export function layout(mainBody) {
    const switchTenantText = (): string => {
        const lsNumOfCompanies = localStorage.getItem("numOfCompanies") || "1";
        const numOfCompanies = parseInt(lsNumOfCompanies, 10);
        let separator = '<span id="SwitchTenantSeparator" class="menu-separator ';
        let anchor = '<a id="SwitchTenant" class="banner-link banner-blue ';
        if (numOfCompanies < 2) {
            separator += "hidden";
            anchor += "hidden";
        }
        separator += '">/</span>';
        anchor += '">Switch Tenant</a>';
        return separator + anchor;
    }
    return (
        '<div id="AppPage" class="hidden"></div>' +
        '<div class="alert-wrapper">' +
        '<div id="AlertContainer" class="alert-container">' +
        "</div>" +
        "</div>" +
        "<button id='JumpToTopButton' class='action-button hidden'></button>" +
        '<div id="SiteContainer" class="site-container" style="opacity: 0;">' +
        '<header id="Banner" class="container banner-class">' +
        '<div class="row banner">' +
        '<div class="col col-xs-9 no-pad">' +
        '<span class="sp-logo-gray"></span>' +
        '<span id="UserInfo">' +
        '<a id="UserName" class="banner-link f-bold" data-bind="text: name"></a>' +
        '<span id="CompanyName" data-bind="text: company"></span>' +
        '<a id="Logout" class="banner-link banner-blue">Log out</a>' +
        switchTenantText() +
        "</span>" +
        "</div>" +
        '<div class="col col-xs-3 flex-align-end no-pad">' +
        "</div>" +
        "</div>" +
        '<div class="row banner pad-t-16">' +
        '<div class="col-xs-9 no-pad" id="NavBar">' +
        '<div class="nav-bar-tab-container">' +
        '<a href="/Home" id="Home" class="nav-bar-tab">' +
        '<i class="fas fa-home"></i>' +
        "</a>" +
        "</div>" +
        '<div class="col-xs-11 no-pad">' +
        '<div id="CallBanner" class="nav-bar-tab-container">' +
        '<span class="nav-bar-tab">' +
        '<span class="skewbackground">' +
        '<div class="unskew"><a id="CallBannerLink" class="banner-link" href="/Call"></a></div>' +
        "</span>" +
        "</span>" +
        '<span class="nav-bar-seperator">/</span>' +
        "</div>" +
        '<div id="OrderBanner" class="nav-bar-tab-container">' +
        '<span class="nav-bar-tab">' +
        '<span class="skewbackground">' +
        '<div class="unskew"><a id="OrderBannerLink" class="banner-link" href="/Order"></a></div>' +
        "</span>" +
        "</span>" +
        '<span class="nav-bar-seperator">/</span>' +
        "</div>" +
        '<div id="RMABanner" class="nav-bar-tab-container">' +
        '<span class="nav-bar-tab">' +
        '<span class="skewbackground">' +
        '<div class="unskew"><a id="RMABannerLink" class="banner-link" href="/RMA"></a></div>' +
        "</span>" +
        "</span>" +
        '<span class="nav-bar-seperator">/</span>' +
        "</div>" +
        '<div id="ContractBanner" class="nav-bar-tab-container">' +
        '<span class="nav-bar-tab">' +
        '<span class="skewbackground">' +
        '<div class="unskew"><a id="ContractBannerLink" class="banner-link" href="/Contract"></a></div>' +
        "</span>" +
        "</span>" +
        '<span class="nav-bar-seperator">/</span>' +
        "</div>" +
        '<div id="QuoteBanner" class="nav-bar-tab-container">' +
        '<span class="nav-bar-tab">' +
        '<span class="skewbackground">' +
        '<div class="unskew"><a id="QuoteBannerLink" class="banner-link" href="/Quote"></a></div>' +
        "</span>" +
        "</span>" +
        '<span class="nav-bar-seperator">/</span>' +
        "</div>" +
        '<div id="InspectionBanner" class="nav-bar-tab-container">' +
        '<span class="nav-bar-tab">' +
        '<span class="skewbackground">' +
        '<div class="unskew"><a id="InspectionBannerLink" class="banner-link" href="/Inspection"></a></div>' +
        "</span>" +
        "</span>" +
        '<span class="nav-bar-seperator">/</span>' +
        "</div>" +
        '<div id="ScheduleBanner" class="nav-bar-tab-container">' +
        '<span class="nav-bar-tab">' +
        '<span class="skewbackground">' +
        '<div class="unskew"><a id="ScheduleBannerLink" class="banner-link" href="/Schedule"></a></div>' +
        "</span>" +
        "</span>" +
        '<span class="nav-bar-seperator">/</span>' +
        "</div>" +
        '<div id="SchedulerPlusBanner" class="nav-bar-tab-container">' +
        '<span class="nav-bar-tab">' +
        '<span class="skewbackground">' +
        '<div class="unskew"><a id="SchedulerPlusBannerLink" class="banner-link" href="/SchedulerPlus"></a></div>' +
        "</span>" +
        "</span>" +
        '<span class="nav-bar-seperator">/</span>' +
        "</div>" +
        '<div id="FinancialBanner" class="nav-bar-tab-container">' +
        '<span class="nav-bar-tab">' +
        '<span class="skewbackground">' +
        '<div class="unskew"><a id="FinancialBannerLink" class="banner-link" href="/Financial"></a></div>' +
        "</span>" +
        "</span>" +
        '<span class="nav-bar-seperator">/</span>' +
        "</div>" +
        '<div id="CustomerBanner" class="nav-bar-tab-container">' +
        '<span class="nav-bar-tab">' +
        '<span class="skewbackground">' +
        '<div class="unskew"><a id="CustomerBannerLink" class="banner-link" href="/Customer"></a></div>' +
        "</span>" +
        "</span>" +
        '<span class="nav-bar-seperator">/</span>' +
        "</div>" +
        '<div id="InventoryBanner" class="nav-bar-tab-container">' +
        '<span class="nav-bar-tab">' +
        '<span class="skewbackground">' +
        '<div class="unskew"><a id="InventoryBannerLink" class="banner-link" href="/Inventory"></a></div>' +
        "</span>" +
        "</span>" +
        '<span class="nav-bar-seperator">/</span>' +
        "</div>" +
        '<div id="MaintenanceBanner" class="nav-bar-tab-container">' +
        '<span class="nav-bar-tab">' +
        '<span class="skewbackground">' +
        '<div class="unskew"><a id="MaintenanceBannerLink" class="banner-link" href="/Maintenance"></a></div>' +
        "</span>" +
        "</span>" +
        '<span class="nav-bar-seperator">/</span>' +
        "</div>" +
        "</div>" +
        "</div>" +
        '<div class="col-xs-3 no-pad">' +
        '<div id="BottomUtilities">' +
        '<ul id="AdminBanner" class="nav navbar-nav navbar-right util-menu">' +
        '<li class="dropdown">' +
        '<a href="#" id="AdminDrop" role="button" class="dropdown-toggle banner-link" data-toggle="dropdown">' +
        '<label id="adminLabel" style="font-weight: normal;"></label>' +
        '<span class="sub-menu"></span>' +
        "</a>" +
        '<ul class="dropdown-menu" role="menu" aria-labelledby="AdminDrop">' +
        '<li><a id="EmployeeBannerLink" class="banner-link bind-label" href="/Employee" data-bind="text: Employee"></a></li>' +
        '<li><a id="PortalUsersBannerLink" class="banner-link bind-label" href="/PortalUsers" data-bind="text: PortalUsers"></a></li>' +
        '<li><a id="RolesRightsBannerLink" class="banner-link bind-label" href="/Roles" data-bind="text: Roles"></a></li>' +
        '<li><a id="DashboardMaintenanceLink" class="banner-link bind-label" data-bind="text: DashboardMaintenance"></a></li>' +
        '<li><a class="banner-link bind-label" style="display: none;" data-bind="text: UserGroups"></a></li>' +
        '<li class="horizontal-seperator" style="display: none;"></li>' +
        '<li><a id="CustomFieldsLink" class="banner-link bind-label" href="/CustomFieldMaintenance" data-bind="text: CF"></a></li>' +
        '<li class="horizontal-seperator" style="display: none;"></li>' +
        '<li><a class="banner-link bind-label" style="display: none;" data-bind="text: CompanySetup"></a></li>' +
        '<li><a id="CompanyFile" class="banner-link bind-label" data-bind="text: CompanyFile"></a></li>' +
        '<li><a id="CrossReferencesLink" class="banner-link bind-label" data-bind="text: CrossReferences"></a></li>' +
        '<li><a id="NotificationsLink" class="banner-link bind-label" data-bind="text: Notifications"></a></li>' +
        '<li id="AboutSep" class="horizontal-seperator"></li>' +
        '<li><a id="AboutServicePro" class="banner-link bind-label" data-bind="text: BrandedAboutInfo"></a></li>' +
        "</ul>" +
        "</li>" +
        "</ul>" +
        '<span id="RASep" class="util-seperator">/</span>' +
        '<ul id="ReportsBanner" class="nav navbar-nav navbar-right util-menu">' +
        '<li class="dropdown">' +
        '<a href="#" id="ReportsDrop" role="button" class="dropdown-toggle banner-link" data-toggle="dropdown">' +
        '<label id="reportLabel" style="font-weight: normal;"></label>' +
        '<span class="sub-menu"></span>' +
        "</a>" +
        '<ul class="dropdown-menu" role="menu" aria-labelledby="ReportsDrop"></ul>' +
        "</li>" +
        "</ul>" +
        "</div>" +
        "</div>" +
        "</div>" +
        "</header>" +
        '<section id="TopToolbar" class="container banner-class">' +
        "</section>" +
        '<section id="Main">' +
        '<div id="AutoSaveContainer"></div>' +
        mainBody +
        '<div class="sp-logo-gray-tagline"></div>' +
        "</section>" +
        "</div>"
    );
}

export const loginLayout =
    '<div class="alert-wrapper">' +
    '<div id="AlertContainer" class="alert-container">' +
    "</div>" +
    '<div id="LoginSiteContainer" class="site-container">' +
    '<section id="LoginMain"></section>' +
    "</div>" +
    '<div id="LoginLoader" class="progress progress-striped active loading-bar" style="display: block; opacity: 0;">' +
    '<span class="loading-bar-message">Loading Login Screen...</span>' +
    '<div class="progress-bar" role="progressbar" style="width: 100%">' +
    "</div>" +
    "</div>";

export const errorLayout =
    "<style>" +
    ".home {" +
    "display: inline-block;" +
    "padding-left: 24px;" +
    "padding-top: 4px;" +
    "width: 0;" +
    "height: 20px;" +
    "cursor: pointer;" +
    "}" +
    ".hidden {" +
    "display: none;" +
    "}" +
    "body {" +
    "margin: 0px;" +
    "opacity: 0;" +
    "color: #606060;" +
    "background-color: #e9e9e9;" +
    "font-family: Segoe UI, Trebuchet MS, Tahoma, Verdana, Arial, sans-serif;" +
    "}" +
    "h1 {" +
    "padding: 10px;" +
    "margin: 20px 30px 5px 30px;" +
    "font-size: 40px;" +
    "}" +
    "h2 {" +
    "padding: 10px;" +
    "margin: 0px 30px;" +
    "font-size: 25px;" +
    "}" +
    "p {" +
    "padding: 10px;" +
    "margin: 0px 30px;" +
    "font-size: 16px;" +
    "}" +
    "a {" +
    "color : #3084bf;" +
    "text-decoration: none;" +
    "z-index: 1000;" +
    "}" +
    "a:hover {" +
    "color: #f89406;" +
    "background-position: -25px -16px;" +
    "}" +
    "</style>";
